import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// import TeamImage from './TeamImage.png'
import { HeaderView } from "../HeaderView/HeaderView";
import { Link } from "react-router-dom";
import { SocialView } from "../SocialView/SocialView";
import { FooterNote } from "../FooterLinks/FooterNote";
import { FooterLinks } from "../FooterLinks/FooterLinks";
import { SearchView } from "../SearchView/SearchView";
import {
  fetchSearchIfNeeded,
  fetchMenusIfNeeded,
  selectQuery,
  CLIENT_BASE_URL
} from "../../actions";

export class SearchGallery extends React.Component {
  constructor(props) {
    super(props);
    this.renderResultSections = this.renderResultSections.bind(this);
    this.renderCards = this.renderCards.bind(this);
    this.gotoPage = this.gotoPage.bind(this);
  }

  drawBackgroundImage(poster) {
    poster = CLIENT_BASE_URL + poster;
    return {
      backgroundImage: `url('${poster}')`
    };
  }

  componentDidMount() {
    const { dispatch, selectedSearchQuery } = this.props;
    let q = selectedSearchQuery;
    if (typeof selectedSearchQuery === "undefined") {
      q = "";
      dispatch(selectQuery(""));
    }

    // console.log('q:', q)
    dispatch(fetchMenusIfNeeded(this.props.selectedScope));
    dispatch(fetchSearchIfNeeded(q));
  }

  componentWillReceiveProps(nextProps) {
    const { match, dispatch } = nextProps;
    if (match.params !== this.props.match.params) {
      dispatch(fetchMenusIfNeeded(nextProps.selectedScope));
    }

    if (this.props.selectedSearchQuery !== nextProps.selectedSearchQuery) {
      dispatch(fetchSearchIfNeeded(nextProps.selectedSearchQuery));
    }
  }

  getVideoUrl(id) {
    return `/filme/${id}`;
  }

  renderResultSections(lbl, resData, resNum) {
    if (resNum === 0) {
      return null;
    }

    let lnkBase = "filme";

    if (lbl === "Filmes") {
      lnkBase = "filme";
    } else if (lbl === "Eventos Paralelos") {
      lnkBase = "actividade";
    } else if (lbl === "Notícias") {
      lnkBase = "noticia";
    }

    return (
      <div key={`sect${lnkBase}`} className={"row searchSection"}>
        <p className={"searchLbl"}>{lbl}</p>
        {this.renderCards(resData, lnkBase)}
      </div>
    );
  }

  renderCards(cards, linkBase) {
    return cards.map((card, i) => {
      const lnk = `/${linkBase}/${card.id}`;
      return (
        <Link key={`mlnk${i}`} to={lnk}>
          <div
            key={`w${i}`}
            className="mosaic col-sm-6 col-md-4 col-lg-4"
            style={{ height: 140, overflow: "hidden" }}
          >
            <div key={`c${i}`} className="col-sm-4 no-pad-right">
              <img src={`${CLIENT_BASE_URL}${card.thumb}`} />
            </div>
            <div key={`d${i}`} className="col-sm-8">
              <p key={`t${i}`}>{card.title}</p>
              <p key={i}>{card.logline}</p>
            </div>
          </div>
        </Link>
      );
    });
  }

  gotoPage(page) {
    this.props.history.push("/pesquisa");
  }

  render() {
    const { menus, dispatch } = this.props;
    const top_menus = menus.top || [];
    const bottom_menus = menus.bottom || [];
    const { results } = this.props;

    let nresults = 0;
    if (Object.keys(results).length && results.found.length) {
      for (let i in results.found) {
        if (results.found[i] !== 0) {
          nresults = results.found[i];
          break;
        }
      }
    }

    if (this.props.isFetchingSearch) {
      return (
        <div>
          <HeaderView top_menus={top_menus} dispatch={dispatch} />
          <div id="searchResults" style={{ textAlign: "center" }}>
            <h2>A pesquisar conteúdos.</h2>
          </div>
        </div>
      );
    }

    if (nresults === 0) {
      return (
        <div>
          <HeaderView top_menus={top_menus} dispatch={dispatch} />
          <div id="searchResults" style={{ textAlign: "center" }}>
            <h2>Não foram encontrados resultados</h2>
            <hr />
            <Link to="/">Voltar à página principal</Link>
          </div>
        </div>
      );
    }

    return (
      <div>
        <HeaderView top_menus={top_menus} dispatch={dispatch} />
        <div id="presentation-view" className="row team-view">
          <div className="col-md-12 no-pad text-left">
            <p className="left-tag">{this.props.selectedSearchQuery}</p>
            <SearchView
              gotoPage={this.gotoPage}
              dispatch={dispatch}
              customStyle={"alignright"}
            />
          </div>
          <div className="row main-block mosaic-container">
            {this.renderResultSections(
              "Filmes",
              results.movies,
              results.found[0]
            )}
            {this.renderResultSections(
              "Notícias",
              results.news,
              results.found[2]
            )}
            {this.renderResultSections(
              "Eventos Paralelos",
              results.festivals,
              results.found[1]
            )}
          </div>
        </div>

        <SocialView customclass="lite" />
        <FooterNote />
        <FooterLinks bottom_menus={bottom_menus} />
      </div>
    );
  }
}

SearchGallery.propTypes = {
  dispatch: PropTypes.func.isRequired,

  menus: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  results: PropTypes.object.isRequired,
  selectedSearchQuery: PropTypes.string.isRequired,
  selectedScope: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  const {
    getMenus,
    selectedSearchQuery,
    getSearchResults,
    selectedScope
  } = state;

  const { isFetchingMenus, lastUpdatedMenus, items: menus } = getMenus[
    selectedScope
  ] || {
    isFetchingMenus: true,
    items: {}
  };

  const { isFetchingSearch, items: results } = getSearchResults[
    selectedSearchQuery
  ] || {
    isFetchingSearch: true,
    items: []
  };

  return {
    isFetchingMenus,
    lastUpdatedMenus,
    menus,
    isFetchingSearch,
    results,
    selectedSearchQuery,
    selectedScope
  };
}

export default connect(mapStateToProps)(SearchGallery);



// WEBPACK FOOTER //
// ./src/views/SearchView/SearchGallery.js